import React from 'react';

import { Paragraph, Spacer } from '@zillow/constellation';

import type { Section } from '../../../../models/index';
import { SEPARATE_HEATING_CHARGE } from '../../../../constants';
import HeaderToggle from '../Utilities/HeaderToggle';
import { CenteredHR } from '../../../Widgets/CenteredHR';
import SwitchWithTitle from '../../../Widgets/SwitchWithTitle';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function SeparateHeatingCharge_v1({ section, setSectionValues }: Props): JSX.Element {
  const heatingChargeApplies = section.getFieldValue(SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED);
  const paysInAdditionToRent = section.getFieldValue(
    SEPARATE_HEATING_CHARGE.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT,
  );

  function toggleUtility(): void {
    setSectionValues({
      [SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED]: !section.getFieldValue(
        SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED,
      ),
      [SEPARATE_HEATING_CHARGE.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT]: false,
    });
  }

  function togglePaysInAddition(): void {
    setSectionValues({
      [SEPARATE_HEATING_CHARGE.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT]: !section.getFieldValue(
        SEPARATE_HEATING_CHARGE.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT,
      ),
    });
  }

  return (
    <>
      <HeaderToggle
        header="Is heat provided separately from other utilities?"
        subheader="Applies to this property"
        switchOn={heatingChargeApplies}
        onSwitchToggle={toggleUtility}
      />
      {heatingChargeApplies && section.getField(SEPARATE_HEATING_CHARGE.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT) && (
        <>
          <Spacer marginBottom="sm">
            <CenteredHR />
            <SwitchWithTitle
              text="Tenant pays in addition to base rent"
              onClick={togglePaysInAddition}
              toggled={paysInAdditionToRent}
            />
          </Spacer>
          {paysInAdditionToRent && (
            <Paragraph>Landlord bills the tenant for a reasonable proportion of actual cost.</Paragraph>
          )}
        </>
      )}
    </>
  );
}
